export enum CaseStatus {
  OPENED = "OPENED",
  CLOSED = "CLOSED",
  IN_PROGRESS = "IN_PROGRESS",
}
